import React, { useState, useCallback, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { FiFileText, FiLogOut } from 'react-icons/fi';
import gecimmoLogo2 from '../../image/gecimmoLogo2.png'; // Assurez-vous que le chemin est correct
import gecimmoLogo from '../../image/gecimmoLogo.png'; // Assurez-vous
import { useNavigate } from 'react-router-dom';
import api from '../../api'




const menuItems = [
  { icon: FiFileText, label: 'Demande', path: '/dg/demande' },
];



function NavItem({ Icon, label, path, collapsed, active, onClick }) {
  return (
    <li>
      <NavLink
        to={path}
        onClick={onClick}
        className={({ isActive }) => `flex items-center gap-4 p-3 rounded-xl transition-colors
          ${(isActive || active) ? 'bg-white text-black' : 'text-gray-100 hover:bg-black hover:text-white'}
          ${collapsed ? 'justify-center' : ''}`}
      >
        <Icon className="w-6 h-6" />
        {!collapsed && <span className="font-medium truncate">{label}</span>}
      </NavLink>
    </li>
  );
}

export default function Sidebar({ onCollapseChange }) {
  const [collapsed, setCollapsed] = useState(false);
  const [activeLabel, setActiveLabel] = useState('Demande');
    const [openSubMenu, setOpenSubMenu] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [showMobileSubMenu, setShowMobileSubMenu] = useState(false);
      const navigate = useNavigate();

      const handleLogout = async () => {
    try {
      await api.post('/logout');  // Appel vers Laravel pour invalider le JWT et supprimer le cookie
      localStorage.clear();       // Nettoyer les données locales
      navigate('/');              // Redirection vers la page login
    } catch (error) {
      console.error('Erreur lors de la déconnexion :', error);
      alert('Impossible de se déconnecter pour le moment.');
    }
  };

    const secondaryItems = [
    { icon: FiLogOut, label: 'Déconnexion', path: '/', onClick: handleLogout },
  ];

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      
      // En mode mobile, on force la sidebar à être "collapsed" (icônes seulement)
      if (mobile) {
        setCollapsed(true);
        onCollapseChange?.(true);
      }
    };

    window.addEventListener('resize', handleResize);
    // Initialiser l'état au chargement
    handleResize();
    
    return () => window.removeEventListener('resize', handleResize);
  }, [onCollapseChange]);

  const handleMouseEnter = () => {
    if (!isMobile) {
      setCollapsed(false);
      onCollapseChange?.(false);
    }
  };

  const handleMouseLeave = () => {
    if (!isMobile) {
      setCollapsed(true);
      onCollapseChange?.(true);
    }
  };

  const handleItemClick = useCallback(label => {
    setActiveLabel(label);
  }, []);

    const handleToggleSubMenu = useCallback(() => {
      if (isMobile) {
        // En mode mobile, afficher le sous-menu dans un overlay
        setShowMobileSubMenu(true);
      } else {
        // En mode desktop, toggle le sous-menu normal
        setOpenSubMenu(prev => !prev);
      }
      setActiveLabel('Paramétrage');
    }, [isMobile]);
  


  return (
    <>
      <aside
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className={`fixed top-0 left-0 h-full bg-terrecuite text-white flex flex-col
          transition-all duration-300 shadow-lg z-40
          ${isMobile ? 'w-20' : (collapsed ? 'w-20' : 'w-64')}`}
      >
        <header className="p-4 border-b border-terrecuite">
          <div className={`flex ${collapsed || isMobile ? 'flex-col items-center space-y-2' : 'items-center justify-between'}`}>
            <img
              src={collapsed || isMobile ? gecimmoLogo2 : gecimmoLogo}
              alt="Logo Gecimmo"
              className="h-12 transition-transform duration-300 hover:scale-105"
            />
          </div>
        </header>

        <nav className="flex-1 p-4 overflow-y-auto">
          <ul className="space-y-1">
            {menuItems.map(item => (
              <NavItem
                key={item.label}
                Icon={item.icon}
                label={item.label}
                path={item.path}
                collapsed={collapsed}
                active={activeLabel === item.label}
                hasSubMenu={item.hasSubMenu}
                isSubMenuOpen={openSubMenu}
                onClick={() => handleItemClick(item.label)}
                onToggleSubMenu={handleToggleSubMenu}
                isMobile={isMobile}
              />
            ))}
          </ul>
        </nav>

<footer className="p-4 border-t border-terrecuite">
  <ul className="space-y-1">
    {secondaryItems.map(item => {
      if(item.label === 'Déconnexion') {
        return (
          <li key={item.label}>
            <button
              onClick={handleLogout}
              className="flex items-center gap-4 p-3 rounded-xl text-gray-100 hover:bg-black hover:text-white w-full"
            >
              <item.icon className="w-6 h-6" />
              {!collapsed && !isMobile && <span>{item.label}</span>}
            </button>
          </li>
        );
      } else {
        return (
          <NavItem
            key={item.label}
            Icon={item.icon}
            label={item.label}
            path={item.path}
            collapsed={collapsed}
            active={activeLabel === item.label}
            onClick={() => handleItemClick(item.label)}
            isMobile={isMobile}
          />
        );
      }
    })}
  </ul>
</footer>

      </aside>
    </>
  );
}